import {Button, Dropdown, Menu} from 'antd';
import {MoreOutlined} from '@ant-design/icons';
import React from 'react';

interface UserActionDropdownProps {
  children: React.ReactNode;
  onClick: (params: {key: string}) => void;
}

export const UserActionDropdown: React.FC<UserActionDropdownProps> = ({children, onClick}) => {
  return (
    <Dropdown dropdownRender={() => <Menu onClick={onClick}>{children}</Menu>} trigger={['click']}>
      <Button type="text" icon={<MoreOutlined />} style={{fontSize: 'inherit'}} />
    </Dropdown>
  );
};
